module.exports = __webpack_public_path__ + "ea54324259d087da144746490d84dcb8.ttf";